import { Box, Fade, Tooltip } from '@mui/material';

import { LegacyNotificationList } from '~/legacy-components/LegacyNotificationList';

import { useLegacyNotificationsPaper } from './useLegacyNotificationsPaper';
import { useSxStyles } from './useStyles';

export const LegacyNotificationsPaper: React.FC = ({ children }) => {
  const sxStyles = useSxStyles();
  const { unreadNotificationsLength } = useLegacyNotificationsPaper();

  return (
    <Tooltip
      placement="bottom-end"
      leaveDelay={0}
      title={<LegacyNotificationList />}
      slots={{ transition: Fade }}
      slotProps={{
        popper: {
          sx: sxStyles.popper,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}
    >
      <Box style={{ position: 'relative' }}>
        {children}
        {!!unreadNotificationsLength && (
          <Box sx={sxStyles.notificationNum}>{unreadNotificationsLength}</Box>
        )}
      </Box>
    </Tooltip>
  );
};
